import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { clearLoginActions } from '../../actions/authentication';
import Link from '../Link';
import Button from '../Button';
import s from './Buttons.css';
import Messages from './Messages';
import { SPIROTECH_URL, TEST_SPIROTECH_URL } from '../../constants/websites';

class Buttons extends React.Component {

  clearLoginActions = () => {
    this.props.clearLoginActions();
  };

  render(){
    const messages = Messages();
    const { elementType, hostname } = this.props;
    switch (elementType) {
      case 'BUTTONS_LOGIN':
        return (
          <div 
            className={s.formGroup} 
            onClick={() => {
              this.clearLoginActions()
            }}
            >
            <span className={s.flex}>
              <Link className={s.link} to="/register">
                <FormattedMessage {...messages.register_now_login_text} />
              </Link>
            </span>
            <span className={s.flex}>
              <Link className={s.link} to="/forgot">
                <FormattedMessage {...messages.forgot_password_login_text} />
              </Link>
            </span>
          </div>
        );
      case 'BUTTONS_CLEAR':
        {
          const isSpirotech = hostname === SPIROTECH_URL || hostname === TEST_SPIROTECH_URL;
          const lightColor = isSpirotech ? 'light_spirotech' : 'light';
          return null;
        }
      default:
        return (
          <div 
            className={s.formGroup} 
            onClick={() => {
              this.clearLoginActions();
            }}
          >
            <span className={s.flex}>
              <Link className={s.link} to="/login">
                <FormattedMessage {...messages.back_to_login} />
              </Link>
            </span>
          </div>
        );
    }
  };
}

Buttons.propTypes = {
  elementType: PropTypes.string.isRequired,
  clearLoginActions: PropTypes.func.isRequired,
  hostname: PropTypes.string,
};

Buttons.defaultProps = {
  hostname: ''
}

const mapDispatch = dispatch => {
  return {
    clearLoginActions: () => dispatch(clearLoginActions()),
  };
};

export default compose(withStyles(s), connect(null, mapDispatch))(
  Buttons
);


// WEBPACK FOOTER //
// ./src/components/LoginElements/Buttons.js